// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3QCaO","emails":"CreateEditClinics_emails__3PLOu","emailTagLabel":"CreateEditClinics_emailTagLabel__1GYeC"};